(function(){
  'use strict';
  if(window.__loviPageInit){ return; }
  window.__loviPageInit = true;

  var ROOT = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';

  function money(cents){
    return (cents/100).toFixed(2).replace('.', ',') + ' \u20AC';
  }

  /* ---------- Badge compteur panier (header) ---------- */
  function syncBadge(count){
    document.querySelectorAll('.m-cart-count, .m-cart-count-bubble').forEach(function(b){
      b.textContent = count;
    });
  }

  /* ---------- Prix barr\u00e9s (compare_at) : cache variant_id -> cents ---------- */
  var compareCache = {};
  function fetchCompares(items){
    var handles = {};
    items.forEach(function(it){
      if(it.handle && compareCache[it.variant_id] === undefined){ handles[it.handle] = true; }
    });
    var list = Object.keys(handles);
    if(!list.length) return Promise.resolve();
    return Promise.all(list.map(function(h){
      return fetch(ROOT + 'products/' + h + '.js', {headers:{'Accept':'application/json'}})
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(p){
          if(p && p.variants){ p.variants.forEach(function(v){ compareCache[v.id] = v.compare_at_price || 0; }); }
        })
        .catch(function(){});
    }));
  }

  /* ---------- Panier lat\u00e9ral (drawer) ---------- */
  var drawerEl = null, overlayEl = null;
  function buildDrawer(){
    if(drawerEl) return;
    var st = document.createElement('style');
    st.textContent = '.lovi-drawer__price{text-align:right;display:flex;flex-direction:column;align-items:flex-end;gap:2px}' +
      '.lovi-drawer__compare{font-size:.8em;color:#9A958B;text-decoration:line-through;font-weight:400}' +
      '.lovi-drawer__totals{border-top:1px dashed #ABB2A4;padding-top:12px;margin-bottom:4px}' +
      '.lovi-drawer__row{display:flex;justify-content:space-between;align-items:center;margin:0 0 8px;font-size:.92rem;color:#383838}' +
      '.lovi-drawer__row--discount{color:#556D61;font-weight:600}' +
      '.lovi-drawer__row--discount .lovi-drawer__tag{display:inline-flex;align-items:center;gap:6px}' +
      '.lovi-drawer__tag-badge{display:inline-block;padding:2px 8px;border:1px dashed #556D61;border-radius:4px;font-size:.78rem;letter-spacing:.04em;text-transform:uppercase}' +
      '.lovi-drawer__total-line{display:flex;flex-direction:column;align-items:flex-end;gap:2px}' +
      '.lovi-drawer__total-compare{font-size:.82em;color:#9A958B;text-decoration:line-through;font-weight:400}';
    document.head.appendChild(st);
    overlayEl = document.createElement('div');
    overlayEl.className = 'lovi-drawer-overlay';
    drawerEl = document.createElement('aside');
    drawerEl.className = 'lovi-drawer';
    drawerEl.setAttribute('role','dialog');
    drawerEl.setAttribute('aria-label','Votre panier');
    drawerEl.innerHTML = '<div class="lovi-drawer__head"><p class="lovi-drawer__title">Votre panier</p><button type="button" class="lovi-drawer__close" aria-label="Fermer">\u2715</button></div>' +
      '<div class="lovi-drawer__items" data-drawer-items></div>' +
      '<div class="lovi-drawer__foot">' +
      '<div class="lovi-drawer__totals">' +
      '<p class="lovi-drawer__row" data-drawer-subtotal-row style="display:none"><span>Sous-total</span><span data-drawer-subtotal></span></p>' +
      '<p class="lovi-drawer__row lovi-drawer__row--discount" data-drawer-discount-row style="display:none"><span class="lovi-drawer__tag"><span class="lovi-drawer__tag-badge">Remise offre</span></span><span data-drawer-discount></span></p>' +
      '<p class="lovi-drawer__total"><span>Total <small>TTC</small></span><span class="lovi-drawer__total-line"><s class="lovi-drawer__total-compare" data-drawer-total-compare style="display:none"></s><span data-drawer-total>\u2014</span></span></p>' +
      '</div>' +
      '<button type="button" class="lovi-btn lovi-btn--full" data-drawer-checkout>COMMANDER <span class="lovi-btn__arrow">\u2192</span></button>' +
      '<p class="lovi-drawer__note">Paiement s\u00e9curis\u00e9 \u00b7 Garantie 90 jours</p></div>';
    document.body.appendChild(overlayEl);
    document.body.appendChild(drawerEl);
    overlayEl.addEventListener('click', closeDrawer);
    drawerEl.querySelector('.lovi-drawer__close').addEventListener('click', closeDrawer);
    drawerEl.querySelector('[data-drawer-checkout]').addEventListener('click', function(){
      window.location.href = ROOT + 'checkout';
    });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeDrawer(); });
  }
  function renderCart(cart){
    buildDrawer();
    fetchCompares(cart.items || []).then(function(){ renderCartNow(cart); });
  }
  function renderCartNow(cart){
    var wrap = drawerEl.querySelector('[data-drawer-items]');
    var totalEl = drawerEl.querySelector('[data-drawer-total]');
    var totalCompareEl = drawerEl.querySelector('[data-drawer-total-compare]');
    var subtotalRow = drawerEl.querySelector('[data-drawer-subtotal-row]');
    var subtotalEl = drawerEl.querySelector('[data-drawer-subtotal]');
    var discountRow = drawerEl.querySelector('[data-drawer-discount-row]');
    var discountEl = drawerEl.querySelector('[data-drawer-discount]');
    var checkoutBtn = drawerEl.querySelector('[data-drawer-checkout]');
    syncBadge(cart.item_count || 0);
    if(!cart.items || !cart.items.length){
      wrap.innerHTML = '<p class="lovi-drawer__empty">Votre panier est vide.<br>Choisissez votre cure pour commencer.</p>';
      totalEl.textContent = money(0);
      totalCompareEl.style.display = 'none';
      subtotalRow.style.display = 'none';
      discountRow.style.display = 'none';
      checkoutBtn.style.display = 'none';
      return;
    }
    checkoutBtn.style.display = '';
    var html = '';
    var totalCompare = 0;
    cart.items.forEach(function(it){
      var isGift = it.final_line_price === 0;
      var img = it.image ? it.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_140x$1$2') : '';
      var compare = compareCache[it.variant_id] || 0;
      var lineCompare;
      if(isGift){
        lineCompare = Math.max(compare * it.quantity, it.original_line_price || 0);
      } else {
        lineCompare = Math.max(compare * it.quantity, it.original_line_price || 0, it.final_line_price);
      }
      totalCompare += lineCompare;
      var priceHtml;
      if(isGift){
        priceHtml = (lineCompare > 0 ? '<s class="lovi-drawer__compare">' + money(lineCompare) + '</s>' : '') + 'OFFERT';
      } else {
        priceHtml = (lineCompare > it.final_line_price ? '<s class="lovi-drawer__compare">' + money(lineCompare) + '</s>' : '') + money(it.final_line_price);
      }
      html += '<div class="lovi-drawer__item">' +
        (img ? '<img class="lovi-drawer__img" src="' + img + '" alt="" loading="lazy">' : '<span class="lovi-drawer__img"></span>') +
        '<div class="lovi-drawer__info"><p class="lovi-drawer__name">' + it.product_title + '</p>' +
        '<p class="lovi-drawer__meta">Qt\u00e9 ' + it.quantity + (isGift ? ' \u00b7 Cadeau inclus' : '') + '</p>' +
        (isGift ? '' : '<button type="button" class="lovi-drawer__remove" data-remove-key="' + it.key + '">Retirer</button>') +
        '</div>' +
        '<span class="lovi-drawer__price' + (isGift ? ' is-gift' : '') + '">' + priceHtml + '</span>' +
        '</div>';
    });
    wrap.innerHTML = html;
    totalEl.textContent = money(cart.total_price);
    if(totalCompare > cart.total_price){
      subtotalEl.textContent = money(totalCompare);
      subtotalRow.style.display = '';
      discountEl.textContent = '\u2212' + money(totalCompare - cart.total_price);
      discountRow.style.display = '';
      totalCompareEl.textContent = money(totalCompare);
      totalCompareEl.style.display = '';
    } else {
      subtotalRow.style.display = 'none';
      discountRow.style.display = 'none';
      totalCompareEl.style.display = 'none';
    }
    wrap.querySelectorAll('[data-remove-key]').forEach(function(btn){
      btn.addEventListener('click', function(){
        btn.disabled = true;
        fetch(ROOT + 'cart/change.js', {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ id: btn.getAttribute('data-remove-key'), quantity: 0 })
        }).then(function(r){ return r.json(); }).then(renderCart).catch(function(){ btn.disabled = false; });
      });
    });
  }
  function refreshDrawer(){
    return fetch(ROOT + 'cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); }).then(renderCart);
  }
  function openDrawer(){
    buildDrawer();
    refreshDrawer().then(function(){
      overlayEl.classList.add('is-open');
      drawerEl.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }
  function closeDrawer(){
    if(!drawerEl) return;
    overlayEl.classList.remove('is-open');
    drawerEl.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* ---------- Header verrouill\u00e9 sur la landing (d\u00e9l\u00e9gation : survit aux re-renders) ---------- */
  function lockHeader(){
    if(!document.querySelector('[data-lovi-offers]')) return;
    document.body.classList.add('lovi-locked-header');
    document.addEventListener('click', function(e){
      var el = e.target.closest ? e.target.closest('a, button, summary') : null;
      if(!el) return;
      if(!el.closest('.shopify-section-group-header-group, #shopify-section-header, header, .m-header')) return;
      if(el.closest('.lovi-drawer')) return;
      var href = (el.getAttribute('href') || '');
      var label = ((el.getAttribute('aria-label') || '') + ' ' + String(el.className || '')).toLowerCase();
      if(href.indexOf('/cart') > -1 || label.indexOf('cart') > -1 || label.indexOf('panier') > -1){
        e.preventDefault(); e.stopPropagation();
        openDrawer();
        return;
      }
      if(el.tagName === 'A'){
        e.preventDefault(); e.stopPropagation();
        window.scrollTo({top:0, behavior:'smooth'});
      }
    }, true);
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', lockHeader); } else { lockHeader(); }

  /* ---------- Carousel (story) ---------- */
  document.querySelectorAll('[data-lovi-carousel]').forEach(function(root){
    var track = root.querySelector('.lovi-carousel__track');
    var slides = root.querySelectorAll('.lovi-carousel__slide');
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    var counter = root.querySelector('[data-counter]');
    var i = 0;
    function go(n){
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      if(counter) counter.textContent = (i + 1) + ' / ' + slides.length;
    }
    if(prev) prev.addEventListener('click', function(){ go(i - 1); });
    if(next) next.addEventListener('click', function(){ go(i + 1); });
    var startX = 0;
    track.addEventListener('touchstart', function(e){ startX = e.touches[0].clientX; }, {passive:true});
    track.addEventListener('touchend', function(e){
      var dx = e.changedTouches[0].clientX - startX;
      if(Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
    }, {passive:true});
    go(0);
  });

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('[data-lovi-faq] .lovi-faq__item').forEach(function(item){
    var q = item.querySelector('.lovi-faq__q');
    var a = item.querySelector('.lovi-faq__a');
    q.addEventListener('click', function(){
      var open = item.classList.contains('is-open');
      item.closest('[data-lovi-faq]').querySelectorAll('.lovi-faq__item.is-open').forEach(function(o){
        o.classList.remove('is-open');
        o.querySelector('.lovi-faq__a').style.maxHeight = null;
      });
      if(!open){
        item.classList.add('is-open');
        a.style.maxHeight = a.scrollHeight + 'px';
      }
    });
  });

  /* ---------- Offers selector + ATC (cadeaux + drawer) ---------- */
  document.querySelectorAll('[data-lovi-offers]').forEach(function(root){
    var offers = root.querySelectorAll('.lovi-offer');
    var atc = root.querySelector('[data-lovi-atc]');
    var stickyBtns = document.querySelectorAll('[data-lovi-sticky-atc]');
    var stickyPrice = document.querySelector('[data-lovi-sticky-price]');
    if(stickyPrice){ stickyPrice.textContent = ''; stickyPrice.style.display = 'none'; }
    var perksMobile = document.querySelector('[data-lovi-perks-mobile]');
    var current = null;
    function select(offer){
      offers.forEach(function(o){ o.classList.remove('is-selected'); });
      offer.classList.add('is-selected');
      current = offer;
      var label = offer.getAttribute('data-cta-label');
      if(label && atc){ atc.querySelector('[data-atc-label]').textContent = label; }
      if(perksMobile){
        var perks = offer.querySelector('.lovi-bundle__perks');
        perksMobile.innerHTML = perks ? perks.outerHTML : '';
        perksMobile.classList.toggle('has-perks', !!perks);
      }
    }
    offers.forEach(function(o){ o.addEventListener('click', function(){ select(o); }); });
    var def = root.querySelector('.lovi-offer[data-default]') || offers[0];
    if(def) select(def);

    function addToCart(){
      if(!current) return;
      var vid = current.getAttribute('data-variant-id');
      if(!vid) return;
      var items = [{ id: parseInt(vid, 10), quantity: 1 }];
      var gifts = current.getAttribute('data-gifts');
      if(gifts){
        gifts.split(',').forEach(function(g){
          g = g.trim();
          if(g) items.push({ id: parseInt(g, 10), quantity: 1 });
        });
      }
      var btns = [atc].concat(Array.prototype.slice.call(stickyBtns)).filter(Boolean);
      btns.forEach(function(b){ b.setAttribute('aria-busy','true'); b.style.opacity = '.7'; });
      fetch(ROOT + 'cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ items: items })
      }).then(function(r){ if(!r.ok) throw new Error('atc'); return r.json(); })
      .then(function(){
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
        openDrawer();
      })
      .catch(function(){ window.location.href = ROOT + 'cart/add?id=' + vid + '&quantity=1'; })
      .finally(function(){ btns.forEach(function(b){ b.removeAttribute('aria-busy'); b.style.opacity = ''; }); });
    }
    if(atc) atc.addEventListener('click', addToCart);
    stickyBtns.forEach(function(b){ b.addEventListener('click', addToCart); });
  });

  /* ---------- Smooth scroll for anchor CTAs ---------- */
  document.querySelectorAll('a[data-lovi-scroll]').forEach(function(a){
    a.addEventListener('click', function(e){
      var t = document.querySelector(a.getAttribute('href'));
      if(t){ e.preventDefault(); t.scrollIntoView({behavior:'smooth', block:'start'}); }
    });
  });

  /* ---------- Smooth scroll for anchor CTAs ---------- */
  var sticky = document.querySelector('[data-lovi-sticky]');
  if(sticky){
    var hero = document.querySelector('.lovi-hero') || document.body;
    var offersEl = document.querySelector('[data-lovi-offers]');
    window.addEventListener('scroll', function(){
      var past = window.scrollY > (hero.offsetHeight || 500);
      var overOffers = false;
      if(offersEl){
        var r = offersEl.getBoundingClientRect();
        overOffers = r.top < window.innerHeight && r.bottom > 0;
      }
      sticky.classList.toggle('is-visible', past && !overOffers);
    }, {passive:true});
  }

  /* ---------- Reveal on scroll ---------- */
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.style.opacity = 1; en.target.style.transform = 'none'; io.unobserve(en.target); } });
    }, {rootMargin:'0px 0px -8% 0px'});
    document.querySelectorAll('[data-lovi-reveal]').forEach(function(el){
      el.style.opacity = 0; el.style.transform = 'translateY(22px)';
      el.style.transition = 'opacity .6s ease, transform .6s ease';
      io.observe(el);
    });
  }
})();
